import { render } from "./MicrosoftOauthDemo.vue?vue&type=template&id=3d3f9ef8"
import script from "./MicrosoftOauthDemo.vue?vue&type=script&lang=js"
export * from "./MicrosoftOauthDemo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__